import { render, staticRenderFns } from "./configMarginFile.vue?vue&type=template&id=05bde336&scoped=true"
import script from "./configMarginFile.vue?vue&type=script&lang=js"
export * from "./configMarginFile.vue?vue&type=script&lang=js"
import style0 from "./configMarginFile.vue?vue&type=style&index=0&id=05bde336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bde336",
  null
  
)

export default component.exports